/*------Accessibility------ */
export const ENTER = 'Enter';
export const SPACE = ' ';

/*------Intercom------ */
export const INTERCOM_LAUNCHER_CLASS = 'intercom-launcher';
export const INTERCOM_LAUNCHER_CLASS_MOBILE = 'intercom-launcher-mobile';
